module.exports = __webpack_public_path__ + "static/media/CS3 -- 5.1043a1bc.jpg";